import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { Alert } from '@softwaredev_cegeka/stix-core'
import DefaultGroupForm from 'src/components/Forms/DefaultGroupForm'
import { authenticatedUserStore, notifierStore } from 'src/stores'
import { AuthApi } from 'src/api/authApi'
import FormLayout from 'src/components/Forms/FormLayout'

class DefaultGroupCreate extends Component {
    authClient = new AuthApi(authenticatedUserStore.authToken)
    state = {
        defaultGroups: [],
        success: false,
    }
    async componentDidMount() {
        let defaultGroups = await this.authClient.fetchDefaultGroups()
        this.setState({ defaultGroups: defaultGroups.data })
    }

    componentWillUnmount() {
        this.authClient.cancelRequest()
    }

    render() {
        if (this.state.success) {
            return <Redirect to={'/groups'} push />
        }
        return (
            <FormLayout {...this.props} entity="default groups">
                <Alert variant="secondary">
                    <p>
                        The groups will be created for tenant{' '}
                        <span className="stix-font-weight-bold">
                            {authenticatedUserStore.userOrganization}
                        </span>
                        .
                    </p>
                    <p>You can select a different tenant in the user menu.</p>
                </Alert>
                <DefaultGroupForm
                    defaultGroups={this.state.defaultGroups}
                    apiClient={this.authClient}
                    onSuccess={response => {
                        notifierStore.setToastInfo(
                            `Successfully created ${response.data.length} group(s)`,
                            true
                        )
                        notifierStore.setShowMessage(true)
                        this.setState({ success: true })
                    }}
                    onError={error => {
                        let message =
                            typeof error.response?.data?.error === 'string'
                                ? error.response.data.error
                                : 'Something went wrong while creating the groups.'

                        notifierStore.setToastInfo(message, false)
                        notifierStore.setShowMessage(true)
                    }}
                    validateOnBlur={false}
                />
            </FormLayout>
        )
    }
}

export default DefaultGroupCreate
